export { ProductHeaderRoot as Root } from './product-header-root'
export { ProductHeaderInfo as Info } from './product-header-info'
